import Vue from 'vue';

((Vue) => {
  "use stricts";

  Vue.component('LogoGunnebo', {
    template: `
      <span class="logo">
        <?xml version="1.0" encoding="utf-8"?>
        <!-- Generator: Adobe Illustrator 17.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="220px" height="40px" viewBox="0 0 220 40" enable-background="new 0 0 220 40" xml:space="preserve">
        <g>
          <g>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" d="M25.884,35.407L25.79,35.31C23.306,38.612,19.533,40,15.473,40
              C2.15,40,0,28.66,0,23.877C0,11.914,6.83,0,21.778,0c8.549,0,15.712,4.305,15.809,14.259h-11.13
              c-0.285-3.541-2.387-4.737-5.349-4.737c-6.496,0-9.359,6.89-9.359,13.446c0,4.497,1.91,7.511,6.685,7.511
              c3.152,0,5.778-1.149,6.972-4.209h-5.349l1.719-8.182h15.617l-4.393,21.004h-7.451L25.884,35.407L25.884,35.407z"/>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" d="M64.342,29.426c-1.527,7.177-6.781,10.335-13.944,10.335
              c-8.501,0-12.035-4.163-12.035-8.71c0-0.526,0.19-1.673,0.286-2.295l3.773-18.134h8.787l-3.247,15.552
              c-0.191,0.86-0.429,2.295-0.429,2.726c0,0.909-0.24,3.779,3.293,3.779c3.631,0,4.729-3.3,5.398-6.409l3.247-15.647h8.74
              L64.342,29.426L64.342,29.426z"/>
            <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" points="71.87,10.621 80.562,10.621 85.911,26.173
              85.959,26.173 89.158,10.621 97.468,10.621 91.498,39.091 82.902,39.091 77.697,23.158 77.601,23.158 74.306,39.091
              65.996,39.091 71.87,10.621 		"/>
            <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" points="101.025,10.621 109.629,10.621 114.979,26.173
              115.074,26.173 118.226,10.621 126.584,10.621 120.614,39.091 112.018,39.091 106.765,23.158 106.716,23.158 103.465,39.091
              95.103,39.091 101.025,10.621 		"/>
            <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" points="130.234,10.621 153.757,10.621 152.302,17.545
              137.559,17.532 136.679,21.725 151.262,21.717 150.068,27.377 135.498,27.369 134.502,32.063 149.257,32.055 147.786,39.091
              124.265,39.091 130.234,10.621 		"/>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" d="M157.242,10.621h14.614c6.161,0,8.5,2.154,8.5,6.269
              c0,3.588-1.814,5.933-5.205,6.842h-0.048v0.096c2.626,0.527,4.299,3.061,4.299,5.692c0,6.842-5.493,9.57-11.701,9.57h-16.333
              L157.242,10.621L157.242,10.621z M161.301,32.296h5.636c1.527,0,3.677-0.527,3.677-2.87c0-2.106-1.529-2.44-3.343-2.44h-4.823
              L161.301,32.296L161.301,32.296z M163.497,21.724h4.967c1.385,0,3.105-0.526,3.105-2.298c0-1.722-1.146-2.009-2.675-2.009h-4.489
              L163.497,21.724L163.497,21.724z"/>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#0084BDF" d="M197.521,9.952c8.022,0,12.894,3.78,12.894,12.488
              c0,9.569-6.257,17.32-15.952,17.32c-8.023,0-12.894-4.258-12.894-12.488C181.569,17.704,187.825,9.952,197.521,9.952
              L197.521,9.952z M194.703,32.678c5.253,0,6.971-6.217,6.971-10.475c0-2.585-1.002-5.168-4.393-5.168
              c-5.254,0-6.973,6.22-6.973,10.43C190.308,30.095,191.311,32.678,194.703,32.678L194.703,32.678z"/>
          </g>
          <g>
            <path fill="#0084BDF" d="M215.874,10.6c2.182,0,4.126,1.572,4.126,4.016c0,2.455-1.945,4.037-4.126,4.037
              c-2.182,0-4.126-1.583-4.126-4.037C211.748,12.172,213.692,10.6,215.874,10.6z M215.874,17.792c1.666,0,3.03-1.335,3.03-3.176
              c0-1.83-1.364-3.154-3.03-3.154c-1.687,0-3.03,1.324-3.03,3.154C212.844,16.457,214.187,17.792,215.874,17.792z M214.273,12.355
              h1.697c1.129,0,1.762,0.355,1.762,1.335c0,0.829-0.516,1.152-1.181,1.206l1.203,1.97h-0.935l-1.096-1.927h-0.537v1.927h-0.913
              V12.355z M215.186,14.239h0.774c0.483,0,0.86-0.075,0.86-0.624c0-0.484-0.516-0.56-0.903-0.56h-0.731V14.239z"/>
          </g>
        </g>
        </svg>
      </span>
    `,
  });

})(Vue);



// WEBPACK FOOTER //
// ./components/logo/logo.js